import type * as React from "react";
import { Link } from "react-router-dom";
import { BsFillPassportFill, BsPeopleFill } from "react-icons/bs";
import { HiArchiveBox, HiHome, HiInbox, HiLockClosed } from "react-icons/hi2";
import { IoLayers } from "react-icons/io5";
import { LuSearch } from "react-icons/lu";
import { MdHelp } from "react-icons/md";
import { RiSendPlaneFill } from "react-icons/ri";

import { Logo } from "@ospra/design-system/components/logo";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarSeparator,
} from "@ospra/design-system/components/sidebar";

import { useAuth } from "@/hooks/useAuth";

import { NavItems } from "./navItems";
import { NavUser } from "./navUser";

const data = {
  navHead: [
    {
      name: "Search",
      url: "/search",
      icon: LuSearch,
      badge: "⌘K",
    },
    {
      name: "Inbox",
      url: "/inbox",
      icon: HiInbox,
      badge: "6",
    },
  ],
  navMain: [
    {
      name: "Overview",
      url: "/overview",
      icon: HiHome,
    },
    {
      name: "Battery Passports",
      url: "/battery-passports",
      icon: BsFillPassportFill,
    },
    {
      name: "Battery Models",
      url: "/battery-models",
      icon: IoLayers,
    },
    {
      name: "Materials",
      url: "/materials",
      icon: HiArchiveBox,
    },
    {
      name: "Partners",
      url: "/partners",
      icon: BsPeopleFill,
    },
    {
      name: "Access Control",
      url: "/access-control",
      icon: HiLockClosed,
    },
  ],
  navTail: [
    {
      name: "Support",
      url: "#",
      icon: MdHelp,
    },
    {
      name: "Feedback",
      url: "#",
      icon: RiSendPlaneFill,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth();

  return (
    <Sidebar variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem className="px-1.5 pt-2">
            <Link to="/overview">
              <Logo className="h-6 w-auto" />
            </Link>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavItems items={data.navHead} />
        <SidebarSeparator className="mx-0" />
        <NavItems itemButtonClassName="h-9.5" items={data.navMain} />
        <NavItems
          className="mt-auto"
          itemButtonClassName="h-8 text-xs"
          items={data.navTail}
        />
      </SidebarContent>
      <SidebarSeparator className="mx-0 my-2" />
      <SidebarFooter>{user ? <NavUser user={user} /> : null}</SidebarFooter>
    </Sidebar>
  );
}
